import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShrink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3" })
	]
});
const ForwardRef = forwardRef(SvgShrink);
export default ForwardRef;
